import { ReactNode } from 'react';
import CampaignFormField from './components/campaignFormField/campaignFormField';

export interface CampaignFormFieldGroupProps {
  children: ReactNode;
  wrapperClassName?: string;
  label: ReactNode;
  labelClassName?: string;
  description?: ReactNode;
  descriptionClassName?: string;
  bordered?: boolean;
}

const CampaignFormFieldGroup = ({
  wrapperClassName,
  label,
  labelClassName,
  description,
  descriptionClassName,
  children,
  bordered,
}: CampaignFormFieldGroupProps) => {
  return (
    <div
      className={`flex flex-col gap-[50px] pb-[50px] ${
        bordered ? 'border-b-[1px] border-[#E8E8E8]' : ''
      } ${wrapperClassName || ''}`}
    >
      <div>
        <h3 className={`text-[26px] font-bold ${labelClassName || ''}`}>
          {label}
        </h3>
        {description && (
          <p
            className={`text-[15px] text-[#999999] ${
              descriptionClassName || ''
            }`}
          >
            {description}
          </p>
        )}
      </div>
      {children}
    </div>
  );
};

CampaignFormFieldGroup.FormField = CampaignFormField;

export default CampaignFormFieldGroup;
